(() => {
  const activatePanel = (section, name) => {
    const panel = [...section.querySelectorAll('[data-va-product-panel]')]
      .find((item) => item.dataset.vaProductPanel === name);
    if (!panel) return null;
    section.querySelectorAll('[data-va-product-panel]').forEach((item) => {
      item.style.display = item === panel ? 'block' : 'none';
    });
    section.querySelectorAll('[data-va-product-tab]').forEach((button) => {
      const selected = button.dataset.vaProductTab === name;
      button.classList.toggle('active', selected);
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
    return panel;
  };

  if (!document.documentElement.dataset.vaProductDetailsBound) {
    document.documentElement.dataset.vaProductDetailsBound = 'true';
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const tab = event.target.closest('[data-va-product-tab]');
      if (tab) {
        const section = tab.closest('[data-va-product-tabs]');
        if (!section) return;
        event.preventDefault();
        activatePanel(section, tab.dataset.vaProductTab);
        return;
      }

      const link = event.target.closest('a[href="#Description"]');
      if (!link || !link.closest('.va-featured-product')) return;
      if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (link.closest('quick-add-modal')) {
        const productUrl = link.closest('product-info')?.dataset.url;
        if (!productUrl) return;
        const destination = new URL(productUrl, location.origin);
        if (destination.origin !== location.origin) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        destination.hash = 'Description';
        location.assign(destination.href);
        return;
      }
      const section = document.querySelector('main [data-va-product-tabs]');
      if (!section) return;
      const description = activatePanel(section, 'Description');
      if (!description) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      description.focus({ preventScroll: true });
      const header = document.querySelector('sticky-header');
      const margin = parseFloat(getComputedStyle(description).scrollMarginTop) || 140;
      const offset = Math.max(margin, (header?.getBoundingClientRect().height || 0) + 24);
      const top = Math.max(0, window.scrollY + description.getBoundingClientRect().top - offset);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top, behavior: reducedMotion ? 'instant' : 'smooth' });
    }, true);

    document.addEventListener('keydown', (event) => {
      if (!(event.target instanceof Element)) return;
      const tab = event.target.closest('[data-va-product-tab]');
      const section = tab?.closest('[data-va-product-tabs]');
      if (!section || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const tabs = [...section.querySelectorAll('[data-va-product-tab]')];
      let index = tabs.indexOf(tab);
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = tabs.length - 1;
      if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      event.preventDefault();
      activatePanel(section, tabs[index].dataset.vaProductTab);
      tabs[index].focus();
    });
  }

  const start = () => {
    if (!document.querySelector('.va-featured-product')) return;
    if (location.hash === '#Description') {
      const section = document.querySelector('main [data-va-product-tabs]');
      if (section) activatePanel(section, 'Description');
    }
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const targets = [
      ...document.querySelectorAll('.va-product-related .collection__title'),
      ...document.querySelectorAll('.va-product-related .product-grid > li'),
      ...document.querySelectorAll('.va-bourbon-comparison'),
      ...document.querySelectorAll('.va-product-details .tab-column-2'),
      ...document.querySelectorAll('main > .shopify-section[id*="collapsible_content"]'),
    ];

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('va-in-view');
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });

    for (const target of targets) {
      if (target.classList.contains('va-scroll-enter')) continue;
      target.classList.add('va-scroll-enter');
      observer.observe(target);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
